module.exports = __webpack_public_path__ + "static/img/music_quiz.b1fef04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/quiz_center/music_quiz.png
// module id = Z1TT
// module chunks = 1